import HomeSlider from "../class/HomeSlider";

new HomeSlider('.home-slider.home-slider--vertical .home-slider-list', {
  headerSelector: '.fortin-header',
  vehicleHeaderSelector: '.vehicle-finder', navigationSelector: '.home-slider-navigation',
  homeSliderList: '.home-slider-list'
}).init();
